var _excluded = ["values", "dragging", "index", "tooltip"];

var _templateObject;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import { arrayOf, number, shape, bool, string } from 'prop-types';
import { hexToRgb } from '@gympass/yoga-common';
import styled from 'styled-components';
import RCHandle from 'rc-slider/lib/Handle';
import Tooltip from './Tooltip';
var Circle = styled(RCHandle)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  height: 24px;\n  margin-top: -10px;\n  outline: none;\n  position: absolute;\n  top: 0;\n  width: 24px;\n  ", "\n"])), function (_ref) {
  var dataDragging = _ref['data-dragging'],
      slider = _ref.theme.yoga.components.slider;
  return "\n    background-color: " + slider.marker.backgroundColor + ";\n    border: 6px solid " + slider.marker.border.color + ";\n    border-radius: " + slider.marker.border.radius + "px;\n    box-shadow: " + (dataDragging ? slider.marker.shadow + ",\n          0 0 0 8px " + hexToRgb(slider.marker.backgroundColor, 0.2) : slider.marker.shadow) + ";\n  ";
});

var Marker = function Marker(_ref2) {
  var values = _ref2.values,
      dragging = _ref2.dragging,
      index = _ref2.index,
      tooltip = _ref2.tooltip,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  var renderTooltip = function renderTooltip() {
    if (!dragging) {
      return false;
    }

    return tooltip.filter(function (_ref3) {
      var step = _ref3.step,
          visible = _ref3.visible;

      if (!step && step !== 0) {
        return visible;
      }

      return visible && values[index] === step;
    })[0];
  };

  return /*#__PURE__*/React.createElement(Circle, _extends({
    "data-dragging": Boolean(dragging)
  }, props), dragging && /*#__PURE__*/React.createElement(Tooltip, {
    data: renderTooltip()
  }));
};

Marker.propTypes = {
  values: arrayOf(number),
  dragging: bool,
  index: number,
  tooltip: arrayOf(shape({
    ribbon: string,
    title: string,
    description: string,
    visible: bool,
    step: number
  }))
};
Marker.defaultProps = {
  values: [0],
  dragging: false,
  index: 0,
  tooltip: undefined
};
export default Marker;